/** Groups seed (prototype screens 17/18/19). Membership lives on the members. */
const GROUP_DATE = (daysAgo) => new Date(Date.now() - daysAgo * 86_400_000).toISOString();

export const buildSeedGroups = () => [
  {
    id: 'grp-engineering',
    name: 'Engineering',
    description: 'Platform and product engineers building integrations and workflows.',
    created_at: GROUP_DATE(380),
  },
  {
    id: 'grp-ai-ops',
    name: 'AI Ops',
    description: 'Responsible for deploying and monitoring AI workers in production.',
    created_at: GROUP_DATE(300),
  },
  {
    id: 'grp-data-team',
    name: 'Data Team',
    description: 'Data engineers and stewards managing model governance and lineage.',
    created_at: GROUP_DATE(260),
  },
  {
    id: 'grp-leadership',
    name: 'Leadership',
    description: 'Executives and directors who lead the business units.',
    created_at: GROUP_DATE(380),
  },
  {
    id: 'grp-compliance',
    name: 'Compliance & Audit',
    description: 'Compliance officers and internal auditors.',
    created_at: GROUP_DATE(150),
  },
  {
    id: 'grp-external',
    name: 'External Consultants',
    description: 'Contracted third-party consultants working on client projects.',
    created_at: GROUP_DATE(90),
  },
];
